<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path
      d="M17.2 21.52a1.6 1.6 0 01-.68-.15.88.88 0 01-.1-.06l-4.36-2.48-4.35 2.48a1.23 1.23 0 01-.11.06 1.61 1.61 0 01-1.62-.15 1.6 1.6 0 01-.62-1.6l1.02-4.92-1.7-1.55-2-1.82a.8.8 0 01-.09-.09 1.58 1.58 0 01.87-2.65.92.92 0 01.1-.02l4.99-.55 2.06-4.57a.73.73 0 01.06-.11 1.59 1.59 0 012.78 0l.06.12 2.06 4.56 4.98.56a.85.85 0 01.11.01 1.59 1.59 0 01.87 2.66l-.08.08-3.7 3.38 1 4.9a1.6 1.6 0 01-.62 1.61 1.58 1.58 0 01-.92.3z"
      fill="currentColor"
    />
  </g>
</template>
